import {Button} from "semantic-ui-react";
import React from "react";
import styles from "./index.module.css";
import {getDoctorId, getObserverId, removeToken} from "../../utils/common";
import history from "../../history";
import agent from "../../agent";
import {ActionLogType} from "../workTableActionLogs/ActionLogModel";
import {getRole, hasRole, UserRole} from "../../helpers/UserRole";

export const Logout = (): JSX.Element => {
    const label: string = `Подтвердите выход`;
    const confirm: string = `Выйти`;

    const onLogout = async (): Promise<void> => {

        await agent.AuthProvider.logout();

        removeToken();

        history.push("/");
    };

    return (
        <div className={styles.container}>

            <div className={styles.label}>
                {label}
            </div>

            <Button
                className={styles.button}
                size={'large'}
                color={'teal'}
                type={'submit'}
                onClick={onLogout}
            >
                {confirm}
            </Button>

        </div>
    )
}